import Vue from "vue";
// Import Froala Editor css files.
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins/align.min";
import "froala-editor/js/plugins/colors.min";
import "froala-editor/js/plugins/font_family.min";
import "froala-editor/js/plugins/font_size.min";
import "froala-editor/js/plugins/line_height.min";
import "froala-editor/js/plugins/link.min";
import "froala-editor/js/plugins/lists.min";
import "froala-editor/js/plugins/quote.min";
import "froala-editor/js/plugins/table.min";
import "froala-editor/js/plugins/url.min";
// import 'froala-editor/js/plugins/spell_checker.min.js';
import "froala-editor/js/plugins/word_paste.min";
// Import and use Vue Froala lib.
import VueFroala from "vue-froala-wysiwyg";

Vue.use(VueFroala);
